<template>
  <div>

    <Head title="Leads" />
    <div class="mb-6 grid grid-cols-4 gap-4">
      <div class="col-span-1">
        <h1 class="mb-8 font-bold text-3xl">Leads</h1>
      </div>
      <div class="col-span-3">
        <CallingNote v-if="calling" :leadId="callingId" :auth="auth" />
      </div>
    </div>
    <div class="mb-2 flex flex-wrap justify-between items-center">
      <div class="md:flex">
        <div class="mr-4">
          <button v-if="!calling && selected.length" id="dialerStart"
            class="rounded-md border-green-800 ring-2 ring-green-800 bg-white p-4 h-12 text-center align-middle text-green-800 hover:bg-green-800 hover:text-white"
            @click="callingToggle()"><i class="far fa-play-circle" /></button>
          <button v-if="calling" id="dialerStart"
            class="rounded-md border-red-500 ring-2 ring-red-500 bg-white p-4 h-12 text-center align-middle text-red-500 text-sm hover:bg-red-500 hover:text-white"
            @click="callingToggle()"><i class="far fa-stop-circle" /></button>
          <EmailMass v-if="emailSelected.length" :emailSelected="emailSelected" :auth="auth" :emailTemplates="emailTemplates" :totalMatchingCount="totalMatchingCount" :selectAllFromDatabase="selectAllFromDatabase" :formFilters="form"
            @update:selected="handleUpdateSelected" />
          <SmsMass v-if="selected.length" :selected="selected" :auth="auth" :smsTemplates="smsTemplates"
            @update:selected="handleUpdateSelected" />
        </div>
        <div class="w-full md:w-auto mb-6 md:mb-0">
          <Link v-if="appCompleteCount > 0" class="min-w-full"
            :href="'/leads?statusFilter=28&loanOfficerFilter=' + auth.user.id">
          <div
            class="rounded-md border-yellow-400 ring-2 ring-yellow-400 bg-white p-2 h-9 text-center text-yellow-400 font-small hover:bg-yellow-400 hover:text-white min-w-full">
            <i class="far fa-bell"></i> {{ appCompleteCount }} New Applications
          </div>
          </Link>
        </div>
      </div>
      <search-filter v-model="form.search" class="w-full mb-6 md:mb-0 max-w-md mr-4" @reset="reset">
        <div v-if="auth.user.owner" class="pb-4">
          <label class="block text-gray-700 font-bold">Loan Officer:</label>
          <select v-model="form.loanOfficerFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="all">All Loan Officers</option>
            <option v-for="lo in loanOfficerFilterList" :key="lo.id" :value="lo.id">{{ lo.first_name }} {{ lo.last_name }}</option>
          </select>
        </div>
        <div class="pb-4">
          <label class="block text-gray-700 font-bold">Status:</label>
          <select v-model="form.statusFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="2">New</option>
            <option value="3">1 Attempt</option>
            <option value="4">2 Attempt</option>
            <option value="5">3 Attempt</option>
            <option value="22">4 Attempt</option>
            <option value="23">5 Attempt</option>
            <option value="24">6 Attempt</option>
            <option value="25">7 Attempt</option>
            <option value="26">8 Attempt</option>
            <option value="28">App Complete</option>
            <option value="6">Contacted</option>
            <option value="7">Waiting</option>
            <option value="8">Not Interested</option>
            <option value="9">Not Eligible</option>
            <option value="10">No Response</option>
            <option value="11">Processing</option>
            <option value="12">Closed</option>
            <option value="13">Pre Approved</option>
            <option value="14">Do Not Contact</option>
            <option value="16">Credit Repair</option>
            <option value="17">Rate Watch</option>
            <option value="19">Deleted</option>
            <option value="20">Call Back</option>
            <option value="21">Junk</option>
          </select>
        </div>
        <div class="pb-4">
          <label class="block text-gray-700 font-bold">Goal:</label>
          <select v-model="form.goalFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="Purchase">Purchase</option>
            <option value="Refinance">Refinance</option>
            <option value="Cashout">Cashout</option>
            <option value="Shorten Term">Shorten Term</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="pb-4">
          <label class="block text-gray-700 font-bold">Loan Type:</label>
          <select v-model="form.loanTypeFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="Conventional">Conventional</option>
            <option value="FHA">FHA</option>
            <option value="FHA 203K">FHA 203K</option>
            <option value="FHA Streamline">FHA Streamline</option>
            <option value="VA">VA</option>
            <option value="USDA">USDA</option>
            <option value="DSCR">DSCR</option>
            <option value="Jumbo">Jumbo</option>
            <option value="HELOC">HELOC</option>
            <option value="Investment">Investment</option>
            <option value="Vacation Home">Vacation Home</option>
            <option value="Park Loan">Park Loan</option>
            <option value="Manufactured">Manufactured</option>
            <option value="Reverse">Reverse</option>
            <option value="Construction">Construction</option>
            <option value="Land">Land</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="pb-4">
          <label class="block text-gray-700 font-bold">Tags:</label>
          <select v-model="form.tagsFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option v-for="tag in sortFunc(tags)" :key="tag" :value="tag">{{ tag }}</option>
          </select>
        </div>
        <div class="pb-4">
          <label class="block text-gray-700 font-bold">Created Date:</label>
          <select v-model="form.rangeFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="7">Past 7 days</option>
            <option value="30">Past 1 Month</option>
            <option value="90">Past 3 Months</option>
            <option value="365">Past 1 Year</option>
            <option value="730">Past 2 Years</option>
            <option value="1095">Past 3 Years</option>
            <option value="1825">Past 5 Years</option>
          </select>
        </div>
        <div class="pb-4">
          <label class="block text-gray-700 font-bold">Closed Date:</label>
          <select v-model="form.rangeClosedFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="2018">2018</option>
            <option value="2019">2019</option>
            <option value="2020">2020</option>
            <option value="2021">2021</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
          </select>
        </div>
        <div class="pb-4">
          <label class="block text-gray-700 font-bold">Not Contacted For:</label>
          <select v-model="form.lastContactFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="1">1 Day</option>
            <option value="2">2 Days</option>
            <option value="3">3 Days</option>
            <option value="5">5 Days</option>
            <option value="7">7 Days</option>
            <option value="15">15 Days</option>
            <option value="30">30 Days</option>
            <option value="90">90 Days</option>
            <option value="180">180 Days</option>
            <option value="365">365 Days</option>
          </select>
        </div>
        <div class="pb-4">
          <label class="block text-gray-700 font-bold">Incoming Contact Received:</label>
          <select v-model="form.incomingContactFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="1">1 Day</option>
            <option value="2">2 Days</option>
            <option value="3">3 Days</option>
            <option value="5">5 Days</option>
            <option value="7">7 Days</option>
            <option value="15">15 Days</option>
            <option value="30">30 Days</option>
            <option value="90">90 Days</option>
            <option value="180">180 Days</option>
            <option value="365">365 Days</option>
          </select>
        </div>
        <div>
          <label class="block text-gray-700 font-bold">Rate Over:</label>
          <select v-model="form.rateFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="3">3.00%</option>
            <option value="3.5">3.50%</option>
            <option value="4">4.00%</option>
            <option value="4.5">4.50%</option>
            <option value="5">5.00%</option>
            <option value="5.5">5.50%</option>
            <option value="6">6.00%</option>
            <option value="6.5">6.50%</option>
            <option value="7">7.00%</option>
            <option value="7.5">7.50%</option>
            <option value="8">8.0%</option>
            <option value="8.5">8.50%</option>
            <option value="9">9.00%</option>
            <option value="9.5">9.50%</option>
            <option value="10">10.00%</option>
            <option value="10.5">10.50%</option>
            <option value="11">11.00%</option>
            <option value="11">11.50%</option>
            <option value="12">12.00%</option>
          </select>
        </div>
      </search-filter>
      <Link class="btn-indigo w-full md:w-auto text-center" href="/leads/create">
        <span><i class="fas fa-plus" /> Create</span>
        <span class="hidden md:inline">&nbsp;Lead</span>
      </Link>
    </div>



    <div class="rounded-md max-w-full p-4 flex flex-wrap justify-between items-center overflow-x-auto">
      <div class="flex flex-wrap  gap-2">

        <div class="hidden md:block p-2 h-9 text-center font-medium text-sm text-gray-500 mr-2"><i class="fas fa-list-ul"></i> Smart Lists:</div>

        <div v-for="list in smartLists" :key="list.id" :id="list.id" class="mr-2">
          <div class="flex flex-column text-center flex-nowrap space-x-0 min-w-full cursor-pointer">
            <Link class="min-w-full" :href="list.filters">
              <div class="rounded-md text-gray-500 bg-white p-2 h-9 text-center font-medium text-sm hover:text-white hover:text-indigo-500 hover:bg-gray-200 hover:border-gray-200 hover:ring-grey-200 whitespace-nowrap pr-6">
                {{ list.name }}
              </div>
            </Link>

            <button class="x-2 py-2" tabindex="-1" @click="destroySmartList(list.id)">
              <i class="-ml-4 fas fa-times text-red-300 mr-2 text-xs hover:text-gray-500"></i>
            </button>

          </div>
        </div>

        <div>
          <div class="flex flex-nowrap space-x-0 min-w-full cursor-pointer">
            <SmartLists class="mt-2" />
          </div>
        </div>

      </div>
    </div>



    <div v-if="allSelected" class="bg-gray-50 p-4 mb-4 rounded-md border border-gray-200">
        <div class="flex items-center">
          <input 
            v-model="selectAllFromDatabase" 
            type="checkbox" 
            class="w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 hover:cursor-pointer"
          />
          <span class="ml-2 text-sm text-gray-600">
            {{ selectAllFromDatabase ? `All ${totalMatchingCount} matching leads selected for Mass Email.` : `${ emailSelected.length } emails selected on this page. Check box to select emails for all ${totalMatchingCount} matching leads.` }}
          </span>
        </div>
    </div>


    <div class="bg-white rounded-md shadow max-w-full">
      <table class="w-full">
        <thead>
          <tr
            class="flex flex-col mb-4 flex-no-wrap md:table-row hover:bg-gray-100 focus-within:bg-gray-100 font-bold overscroll-y-auto hidden md:block">
            <th class="hidden md:block mt-2"><input v-model="allSelected" type="checkbox" class="m-2 w-5 h-5 hover:cursor-pointer"
                @click="selectAll" /></th>
            <th class="pt-4 pb-4">Status</th>
            <th class="pt-4 pb-4">Name</th>
            <th class="pt-4 pb-4">Contact</th>
            <th class="pt-4 pb-4 max-w-xs">Address</th>
            <th class="pt-4 pb-4">Type</th>
            <th class="pt-4 pb-4">Date</th>
            <th class="pt-4 pb-4">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="lead in leads.data" :id="lead.id + 'row'" :ref="lead.id + 'row'" :key="lead.id"
            class="flex even:bg-gray-100 flex-col mb-4 flex-no-wrap md:table-row border-t-2 md:border-0 text-left md:p-0 overscroll-y-auto hover:bg-gray-100 focus-within:bg-gray-100 hover:bg-gray-100">
            <td class="md:border-t">
              <input 
                v-if="lead.phone || lead.email"
                :id="lead.id + 'checkbox'" 
                :checked="selected.includes(lead.id) || emailSelected.includes(lead.id)"
                type="checkbox"
                class="hidden md:block m-2 w-4 h-4 hover:cursor-pointer" 
                @click="select(lead.id)"
              />
              <input 
                v-if="lead.phoneCoborrower || lead.emailCoborrower"
                :checked="selected.includes(lead.id + 'co') || emailSelected.includes(lead.id + 'co')"
                type="checkbox"
                class="hidden md:block m-2 w-4 h-4"
                @click="selectCo(lead.id + 'co')"
              />
            </td>
            <td class="md:border-t py-4">
              <div v-if="lead.user" class="flex items-center md:justify-start justify-center">
                <div>
                  <img v-if="lead.user.photo_path" class="block -my-2 mr-2 w-5 h-5 rounded-full"
                    :src="'img/' + lead.user.photo_path + '?w=40&h=40&fit=crop'" />
                </div>
                <div class="align-middle pt-0 md:text-xs">{{ lead.user.first_name }} {{ lead.user.last_name }}</div>
              </div>
              <div v-if="lead.processor" class="flex items-center md:justify-start justify-center">
                <div>
                  <img v-if="lead.processor.photo_path" class="block -my-2 mr-2 w-5 h-5 rounded-full"
                    :src="'img/' + lead.processor.photo_path + '?w=40&h=40&fit=crop'" />
                  <div v-if="!lead.processor.photo_path"
                    class="flex items-center justify-center -my-2 mr-2 w-5 h-5 rounded-full bg-blue-200">
                    <span class="text-xs text-white font-light subpixel-antialiased tracking-tighter">
                      {{ lead.processor.first_name.charAt(0).toUpperCase() }}{{
                        lead.processor.last_name.charAt(0).toUpperCase() }}
                    </span>
                  </div>
                </div>
                <div class="align-middle pt-0 md:text-xs">{{ lead.processor.first_name }} {{ lead.processor.last_name }}
                </div>
              </div>
              <!-- <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="`/leads/${lead.id}/edit`"> -->
              <div v-if="!lead.deleted_at" class="w-full mt-4">
                <div v-if="lead.status === 28" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-blue-500 ring-2 ring-blue-500 bg-white p-2 h-9 text-center text-blue-500 font-medium text-sm hover:bg-blue-500 hover:text-white min-w-full">
                    App Complete</div>
                  </Link>
                </div>
                <div v-if="lead.status === 0" class="flex flex-no-wrap space-x-0 min-w-full pr-4">
                  <Link class="min-w-full " :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md rounded-r-none ring-2 ring-red-500 bg-white p-2 h-9 text-center text-red-500 font-medium text-sm hover:bg-red-500 hover:text-white min-w-full">
                    New</div>
                  </Link>
                  <div
                    class="rounded-md inline-block rounded-l-none ring-2 ring-red-500 bg-white h-9 text-red-500 p-1 pt-2 cursor-pointer hover:bg-red-500 hover:text-white"
                    @click="status(lead.id)">
                    <i class="fas fa-angle-right align-middle" />
                  </div>
                </div>
                <div v-if="lead.status === 1" class="flex flex-no-wrap space-x-0 min-w-full pr-4">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md rounded-r-none ring-2 ring-gray-500 bg-white p-2 h-9 text-center text-gray-500 font-medium text-sm hover:bg-gray-500 hover:text-white min-w-full">
                    Contacted</div>
                  </Link>
                  <div
                    class="rounded-md inline-block rounded-l-none ring-2 ring-gray-500 bg-white h-9 text-gray-500 p-1 pt-2 cursor-pointer hover:bg-gray-500 hover:text-white"
                    @click="status(lead.id)">
                    <i class="fas fa-angle-right align-middle" />
                  </div>
                </div>
                <div v-if="lead.status === 2" class="flex flex-no-wrap space-x-0 min-w-full pr-4">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md rounded-r-none ring-2 ring-red-500 bg-white p-2 h-9 text-center text-red-500 font-light text-sm hover:bg-red-500 hover:text-white min-w-full">
                    New</div>
                  </Link>
                  <div
                    class="rounded-md inline-block rounded-l-none ring-2 ring-red-500 bg-white h-9 text-red-500 p-1 pt-2 cursor-pointer text-sm font-light hover:bg-red-500 hover:text-white"
                    @click="status(lead.id)">
                    <i class="fas fa-angle-right align-middle" />
                  </div>
                </div>
                <div v-if="lead.status === 3" class="flex flex-no-wrap space-x-0 min-w-full pr-4">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md rounded-r-none ring-2 ring-red-400 bg-white p-2 h-9 text-center text-red-400 font-medium text-sm hover:bg-red-400 hover:text-white min-w-full">
                    1 Attempt</div>
                  </Link>
                  <div
                    class="rounded-md inline-block rounded-l-none ring-2 ring-red-400 bg-white h-9 text-red-400 p-1 pt-2 cursor-pointer hover:bg-red-400 hover:text-white"
                    @click="status(lead.id)">
                    <i class="fas fa-angle-right align-middle" />
                  </div>
                </div>
                <div v-if="lead.status === 4" class="flex flex-no-wrap space-x-0 min-w-full pr-4">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md rounded-r-none ring-2 ring-red-300 bg-white p-2 h-9 text-center text-red-300 font-medium text-sm hover:bg-red-300 hover:text-white min-w-full">
                    2 Attempt</div>
                  </Link>
                  <div
                    class="rounded-md inline-block rounded-l-none ring-2 ring-red-300 bg-white h-9 text-red-300 p-1 pt-2 cursor-pointer hover:bg-red-300 hover:text-white"
                    @click="status(lead.id)">
                    <i class="fas fa-angle-right align-middle" />
                  </div>
                </div>
                <div v-if="lead.status === 5" class="flex flex-no-wrap space-x-0 min-w-full pr-4">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md rounded-r-none ring-2 ring-red-200 bg-white p-2 h-9 text-center text-red-200 font-medium text-sm hover:bg-red-200 hover:text-white min-w-full">
                    3 Attempt</div>
                  </Link>
                  <div
                    class="rounded-md inline-block rounded-l-none ring-2 ring-red-200 bg-white h-9 text-red-200 p-1 pt-2 cursor-pointer hover:bg-red-200 hover:text-white"
                    @click="status(lead.id)">
                    <i class="fas fa-angle-right align-middle" />
                  </div>
                </div>
                <div v-if="lead.status === 22" class="flex flex-no-wrap space-x-0 min-w-full pr-4">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md rounded-r-none ring-2 ring-red-200 bg-white p-2 h-9 text-center text-red-200 font-medium text-sm hover:bg-red-200 hover:text-white min-w-full">
                    4 Attempt</div>
                  </Link>
                  <div
                    class="rounded-md inline-block rounded-l-none ring-2 ring-red-200 bg-white h-9 text-red-200 p-1 pt-2 cursor-pointer hover:bg-red-200 hover:text-white"
                    @click="status(lead.id)">
                    <i class="fas fa-angle-right align-middle" />
                  </div>
                </div>
                <div v-if="lead.status === 23" class="flex flex-no-wrap space-x-0 min-w-full pr-4">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md rounded-r-none ring-2 ring-red-200 bg-white p-2 h-9 text-center text-red-200 font-medium text-sm hover:bg-red-200 hover:text-white min-w-full">
                    5 Attempt</div>
                  </Link>
                  <div
                    class="rounded-md inline-block rounded-l-none ring-2 ring-red-200 bg-white h-9 text-red-200 p-1 pt-2 cursor-pointer hover:bg-red-200 hover:text-white"
                    @click="status(lead.id)">
                    <i class="fas fa-angle-right align-middle" />
                  </div>
                </div>
                <div v-if="lead.status === 24" class="flex flex-no-wrap space-x-0 min-w-full pr-4">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md rounded-r-none ring-2 ring-red-200 bg-white p-2 h-9 text-center text-red-200 font-medium text-sm hover:bg-red-200 hover:text-white min-w-full">
                    6 Attempt</div>
                  </Link>
                  <div
                    class="rounded-md inline-block rounded-l-none ring-2 ring-red-200 bg-white h-9 text-red-200 p-1 pt-2 cursor-pointer hover:bg-red-200 hover:text-white"
                    @click="status(lead.id)">
                    <i class="fas fa-angle-right align-middle" />
                  </div>
                </div>
                <div v-if="lead.status === 25" class="flex flex-no-wrap space-x-0 min-w-full pr-4">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md rounded-r-none ring-2 ring-red-200 bg-white p-2 h-9 text-center text-red-200 font-medium text-sm hover:bg-red-200 hover:text-white min-w-full">
                    7 Attempt</div>
                  </Link>
                  <div
                    class="rounded-md inline-block rounded-l-none ring-2 ring-red-200 bg-white h-9 text-red-200 p-1 pt-2 cursor-pointer hover:bg-red-200 hover:text-white"
                    @click="status(lead.id)">
                    <i class="fas fa-angle-right align-middle" />
                  </div>
                </div>
                <div v-if="lead.status === 26" class="flex flex-no-wrap space-x-0 min-w-full pr-4">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md rounded-r-none ring-2 ring-red-200 bg-white p-2 h-9 text-center text-red-200 font-medium text-sm hover:bg-red-200 hover:text-white min-w-full">
                    8 Attempt</div>
                  </Link>
                  <div
                    class="rounded-md inline-block rounded-l-none ring-2 ring-red-200 bg-white h-9 text-red-200 p-1 pt-2 cursor-pointer hover:bg-red-200 hover:text-white"
                    @click="status(lead.id)">
                    <i class="fas fa-angle-right align-middle" />
                  </div>
                </div>
                <div v-if="lead.status === 6" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-gray-500 ring-2 ring-gray-500 bg-white p-2 h-9 text-center text-gray-500 font-medium text-sm hover:bg-gray-500 hover:text-white min-w-full">
                    Contacted</div>
                  </Link>
                </div>
                <div v-if="lead.status === 7" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-gray-400 ring-2 ring-gray-400 bg-white p-2 h-9 text-center align-middle text-gray-400 font-medium text-sm hover:bg-gray-400 hover:text-white">
                    Waiting</div>
                  </Link>
                </div>
                <div v-if="lead.status === 8" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-blue-900 ring-2 ring-blue-900 bg-white p-2 h-9 text-center align-middle text-blue-900 font-medium text-sm hover:bg-blue-900 hover:text-white">
                    Not Interested</div>
                  </Link>
                </div>
                <div v-if="lead.status === 9" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-gray-700 ring-2 ring-gray-700 bg-white p-2 h-9 text-center align-middle text-gray-700 font-medium text-sm hover:bg-gray-700 hover:text-white">
                    Not Eligible</div>
                  </Link>
                </div>
                <div v-if="lead.status === 10" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-indigo-700 ring-2 ring-indigo-500 bg-white p-2 h-9 text-center align-middle text-indigo-500 font-medium text-sm hover:bg-indigo-500 hover:text-white">
                    No Response</div>
                  </Link>
                </div>
                <div v-if="lead.status === 11" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-green-400 ring-2 ring-green-400 bg-white p-2 h-9 text-center align-middle text-green-400 font-medium text-sm hover:bg-green-400 hover:text-white">
                    Processing</div>
                  </Link>
                </div>
                <div v-if="lead.status === 12" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-green-800 ring-2 ring-green-800 bg-white p-2 h-9 text-center align-middle text-green-800 font-medium text-sm hover:bg-green-800 hover:text-white">
                    Closed</div>
                  </Link>
                </div>
                <div v-if="lead.status === 13" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-pink-400 ring-2 ring-pink-400 bg-white p-2 h-9 text-center align-middle text-pink-400 font-medium text-sm hover:bg-pink-400 hover:text-white">
                    PreApproved</div>
                  </Link>
                </div>
                <div v-if="lead.status === 14" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-gray-900 ring-2 ring-gray-900 bg-white p-2 h-9 text-center align-middle text-gray-900 font-medium text-sm hover:bg-gray-900 hover:text-white">
                    Do Not Contact</div>
                  </Link>
                </div>
                <div v-if="lead.status === 15" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-yellow-500 ring-2 ring-yellow-500 bg-white p-2 h-9 text-center align-middle text-yellow-500 font-medium text-sm hover:bg-yellow-500 hover:text-white">
                    Realtor</div>
                  </Link>
                </div>
                <div v-if="lead.status === 16" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-yellow-800 ring-2 ring-yellow-800 bg-white p-2 h-9 text-center align-middle text-yellow-800 font-medium text-sm hover:bg-yellow-800 hover:text-white">
                    Credit Repair</div>
                  </Link>
                </div>
                <div v-if="lead.status === 17" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-green-300 ring-2 ring-green-300 bg-white p-2 h-9 text-center align-middle text-green-300 font-medium text-sm hover:bg-green-300 hover:text-white">
                    Rate Watch</div>
                  </Link>
                </div>
                <div v-if="lead.status === 18" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-yellow-500 ring-2 ring-yellow-500 bg-white p-2 h-9 text-center align-middle text-yellow-500 font-medium text-sm hover:bg-yellow-500 hover:text-white">
                    Referral Partner</div>
                  </Link>
                </div>
                <div v-if="lead.status === 19" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-purple-400 ring-2 ring-purple-400 bg-white p-2 h-9 text-center align-middle text-purple-400 font-medium text-sm hover:bg-purple-400 hover:text-white">
                    Deleted</div>
                  </Link>
                </div>
                <div v-if="lead.status === 20" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-blue-500 ring-2 ring-blue-500 bg-white p-2 h-9 text-center align-middle text-blue-500 font-medium text-sm hover:bg-blue-500 hover:text-white">
                    Call Back</div>
                  </Link>
                </div>
                <div v-if="lead.status === 21" class="min-w-full">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-blue-500 ring-2 ring-gray-500 bg-white p-2 h-9 text-center align-middle text-gray-500 font-medium text-sm hover:bg-gray-500 hover:text-white">
                    Junk</div>
                  </Link>
                </div>
              </div>
              <!-- </Link> -->
              <div v-if="lead.deleted_at" class="w-full mt-4">
                <div class="min-w-full pr-4">
                  <Link class="min-w-full" :href="`/leads/${lead.id}/edit`">
                  <div
                    class="rounded-md border-purple-400 ring-2 ring-purple-400 bg-white p-2 h-9 text-center align-middle text-purple-400 font-medium text-sm hover:bg-purple-400 hover:text-white">
                    Deleted</div>
                  </Link>
                </div>
              </div>
              <div v-if="lead.latest_note" class="min-w-full text-center pt-2 pb-2 text-xs">Last Contacted:
                <IconNotes :name="lead.latest_note.type" :customClasses="{ email: 'text-sm', called: 'text-sm', text: 'text-sm'}" /> {{ datestamp(lead.latest_note.created_at) }}
              </div>
            </td>
            <td class="md:border-t">
              <Link class="flex items-center pl-6 pr-3 py-4 focus:text-indigo-500" :href="`/leads/${lead.id}/edit`"
                :preserve-state="false">
              <div class="flex flex-col w-full">
                <div class="pb-2 text-center text-xl md:text-left md:text-sm">{{ lead.fullName }}</div>
                <div class="pb-2 text-center text-xl md:text-left md:text-sm">{{ lead.fullNameCoborrower }}</div>
                <div v-for="(each, index) in duplicates" :key="index">
                  <div v-if="each.email == lead.email && each.id != lead.id">
                    <Link :href="`/leads/${each.id}/edit`">
                    <div
                      class="rounded-md mt-2 border-yellow-500 ring-1 ring-yellow-500 bg-white pt-1 pb-2 h-6 text-center align-middle text-yellow-500 font-normal text-xs hover:bg-yellow-400 hover:text-white mr-3">
                      duplicate</div>
                    </Link>
                  </div>
                </div>
              </div>
              </Link>
            </td>
            <td class="md:border-t">
              <div class="px-3 md:p-0 flex flex-col mb-2 lg:max-w-xs text-center text-xl md:text-left md:text-sm">
                <div v-if="!!lead.phone" class="pt-2 pb-2"><a :id="lead.id + 'phone'"
                    :href="'tel:+' + phoneFormatted(lead.phone)"><i
                      class="fas fa-phone-alt text-green-500 text-sm" /></a> <a
                    :href="'sms:+' + phoneFormatted(lead.phone)"><i
                      class="fas fa-sms text-indigo-600 mx-2 text-sm" /></a> {{ phoneShow(lead.phone) }}</div>
                <div v-if="!!lead.phoneCoborrower" class="pb-2"><a :id="lead.id + 'cophone'"
                    :href="'tel:+' + phoneFormatted(lead.phoneCoborrower)"><i
                      class="fas fa-phone-alt text-green-500 text-sm" /></a> <a
                    :href="'sms:+' + phoneFormatted(lead.phoneCoborrower)"><i
                      class="fas fa-sms text-indigo-600 mx-2 text-sm" /></a> {{ phoneShow(lead.phoneCoborrower) }}
                </div>
                <div class="pb-2 overflow-hidden">{{ lead.email }}</div>
                <div class="overflow-hidden">{{ lead.emailCoborrower }}</div>
              </div>
            </td>
            <td class="md:border-t overflow-x-hidden lg:max-w-xs">
              <Link class="flex items-center px-3 py-4 focus:text-indigo-500" :href="`/leads/${lead.id}/edit`"
                :preserve-state="false">
              <div class="flex flex-col w-full text-center text-xl md:text-left md:text-sm">
                <div v-if="lead.address" class="pb-2">{{ lead.address }}</div>
                <div>{{ lead.city }}{{ (!!lead.city) ? ', ' : '' }} {{ lead.state }}{{ (!!lead.state) ? ', ' : '' }} {{
                  lead.zip }}</div>
              </div>
              </Link>
            </td>
            <td class="md:border-t">
              <Link class="flex items-center px-3 py-4 focus:text-indigo-500" :href="`/leads/${lead.id}/edit`"
                :preserve-state="false">
              <div class="flex flex-col w-full text-center text-xl md:text-left md:text-sm">
                <div class="pb-2">{{ lead.goal }}</div>
                <div class="pb-2">{{ lead.loan_type }}</div>
                <div v-if="lead.balance" class="pb-2">$ {{ lead.balance.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,
                  '$1,') }}</div>
              </div>
              </Link>
            </td>
            <td class="md:border-t">
              <div class="px-3 md:p-0 flex flex-col w-full text-center text-xl md:text-left md:text-sm">
                <div class="pb-2 md:text-sm">Created: {{ datestamp(lead.created_at) }} {{ timestamp(lead.created_at) }}
                </div>
                <div v-if="lead.updated_at != null" class="pb-2 md:text-sm">Updated: {{ datestamp(lead.updated_at) }} {{
                  timestamp(lead.updated_at) }}</div>
                <div v-if="lead.closed != null && lead.closed != ''" class="pb-2 md:text-sm">Closed: {{
                  datestamp(lead.closed) }}</div>
                <div v-if="lead.rate != null && lead.rate != ''" class="pb-2 md:text-sm">Rate: {{ lead.rate }}</div>
              </div>
            </td>
            <td class="px-3 md:px-0 md:p-0 md:border-t">
              <div class="w-full text-center text-3xl md:text-xl md:text-right">
                <Link class="px-6 py-4 focus:text-indigo-500" :href="`/leads/${lead.id}/edit`"
                  :preserve-state="false"><i
                  class="far fa-edit text-indigo-500" /></Link>
                <button v-if="!lead.deleted_at" class="text-red-600 px-2 py-2 hover:underline" tabindex="-1"
                  type="button" @click="destroy(lead.id)"><i class="ml-2 far fa-trash-alt text-red-500" /></button>
              </div>
            </td>
          </tr>
          <tr v-if="leads.data.length === 0">
            <td class="border-t px-6 py-4" colspan="8">No leads found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex flex-wrap justify-between align-center">
      <div class="pb-4 mt-6">
        <label class="block text-gray-700 font-bold">Per Page:</label>
        <select v-model="form.perPageFilter" class="mt-1 form-select">
          <option :value="null" />
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="150">150</option>
          <option value="200">200</option>
          <option value="250">250</option>
          <option value="500">500</option>
        </select>
      </div>
      <pagination class="mt-6" :links="leads.links" />
    </div>
  </div>
</template>
<script>
import { Head, Link, router, usePoll } from '@inertiajs/vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import EmailMass from '@/Shared/EmailMass'
import SmsMass from '@/Shared/SmsMass'
import CallingNote from '@/Shared/CallingNote'
import moment from 'moment'
import { ref, onMounted, onUnmounted, computed } from 'vue'
import SmartLists from '@/Shared/SmartLists'
import IconNotes from '@/Shared/IconNotes'

export default {
  name: 'LeadsIndex',
  components: {
    Head,
    Link,
    Pagination,
    CallingNote,
    SearchFilter,
    EmailMass,
    SmsMass,
    SmartLists,
    IconNotes,
  },
  layout: Layout,
  props: {
    filters: Object,
    leads: Object,
    duplicates: Array,
    auth: Object,
    emailTemplates: Array,
    smsTemplates: Array,
    tags: Array,
    appCompleteCount: String,
    loanOfficerFilterList: Array,
    smartLists: Object,
    totalMatchingCount: Number,
  },
  setup() {
    const isPolling = ref(false)
    let pollInterval = null

    const startPolling = () => {
      if (!isPolling.value) {
        isPolling.value = true;
        pollInterval = setInterval(() => {
          router.reload({
            only: ['leads'],
            preserveState: false,
            preserveScroll: true,
            replace: true,
          });
        }, 30000);
      }
    };

    const stopPolling = () => {
      if (isPolling.value) {
        isPolling.value = false
        clearInterval(pollInterval)
      }
    }

    onMounted(() => {
      startPolling()
    })

    onUnmounted(() => {
      stopPolling()
    })

    return {
      isPolling,
      startPolling,
      stopPolling
    }
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        statusFilter: this.filters.statusFilter,
        loanTypeFilter: this.filters.loanTypeFilter,
        goalFilter: this.filters.goalFilter,
        rateFilter: this.filters.rateFilter,
        rangeFilter: this.filters.rangeFilter,
        rangeClosedFilter: this.filters.rangeClosedFilter,
        tagsFilter: this.filters.tagsFilter,
        loanOfficerFilter: this.filters.loanOfficerFilter,
        lastContactFilter: this.filters.lastContactFilter,
        incomingContactFilter: this.filters.incomingContactFilter,
        perPageFilter: this.filters.perPageFilter,
      },
      calling: false,
      callingId: '',
      selected: [],
      emailSelected: [],
      allSelected: false,
      selectAllFromDatabase: false,
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        // Reset selected and emailSelected when filters change
        this.selected = [];
        this.emailSelected = [];
        this.allSelected = false;
        this.selectAllFromDatabase = false;
        
        router.get('/leads', pickBy(this.form), { preserveState: true })
      }, 500),
    },
  },
  mounted() {
    const queryParams = this.$page.props.url
    console.log(queryParams)
    window.addEventListener('message', (e) => {
      this.phoneCall(e)
    })
  },
  unmounted() {
    // Clean up selection state only
    this.selected = [];
    this.emailSelected = [];
    this.allSelected = false;
    this.selectAllFromDatabase = false;
  },
  methods: {
    sortFunc: function (tags) {
      return tags.slice().sort(function (a, b) {
        return (a > b) ? 1 : -1
      })
    },
    selectAll() {
      if (!this.allSelected) {
        this.selected = [];
        this.emailSelected = [];
        
        this.leads.data.forEach(lead => {
          // Add primary borrower if they have phone/email
          if (lead.phone) {
            this.selected.push(lead.id);
          }
          if (lead.email) {
            this.emailSelected.push(lead.id);
          }

          // Add co-borrower if they have phone/email
          if (lead.phoneCoborrower) {
            this.selected.push(`${lead.id}co`);
          }
          if (lead.emailCoborrower) {
            this.emailSelected.push(`${lead.id}co`);
          }
        });
      } else {
        // Deselect everything
        this.selected = [];
        this.emailSelected = [];
      }
      this.allSelected = !this.allSelected;
    },
    select(leadId) {
      const lead = this.leads.data.find(l => l.id === leadId);
      if (!lead) return;

      const isSelected = this.selected.includes(leadId);
      
      // Toggle primary borrower selection
      if (isSelected) {
        this.selected = this.selected.filter(id => id !== leadId);
        this.emailSelected = this.emailSelected.filter(id => id !== leadId);
      } else {
        if (lead.phone) {
          this.selected.push(leadId);
        }
        if (lead.email) {
          this.emailSelected.push(leadId);
        }
      }

      this.allSelected = false;
    },
    selectCo(coId) {
      const leadId = parseInt(coId.replace('co', ''));
      const lead = this.leads.data.find(l => l.id === leadId);
      if (!lead) return;

      const isSelected = this.selected.includes(coId);

      // Toggle co-borrower selection
      if (isSelected) {
        this.selected = this.selected.filter(id => id !== coId);
        this.emailSelected = this.emailSelected.filter(id => id !== coId);
      } else {
        if (lead.phoneCoborrower) {
          this.selected.push(coId);
        }
        if (lead.emailCoborrower) {
          this.emailSelected.push(coId);
        }
      }

      this.allSelected = false;
    },
    handleUpdateSelected(newValue) {
      this.selected = [...newValue];
      this.emailSelected = [...newValue];
      this.allSelected = false;
    },
    timestamp: function (date) {
      return moment(date).format('h:mm A')
    },
    datestamp: function (date) {
      return moment(date).format('MM/DD/YY')
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    destroy(id) {
      console.log(id)
      if (confirm('Are you sure you want to delete this contact?')) {
        router.delete('/leads/' + id, { only: ['leads'], preserveScroll: true })
      }
    },
    destroySmartList(id) {
      if (confirm('Are you sure you want to delete this Smart List?')) {
        router.delete('/smartLists/' + id, { only: ['smartLists'], preserveScroll: true })
      }
    },
    status(id) {
      router.put('/leads/' + id + '/status', '', { preserveScroll: true })
    },
    sleep(milliseconds) {
      const date = Date.now()
      let currentDate = null
      do {
        currentDate = Date.now()
      } while (currentDate - date < milliseconds)
    },
    callingToggle() {
      this.calling = !this.calling
      this.loop()
    },
    loop() {
      if (!this.calling) return
      if (this.selected.length === 0) {
        this.calling = false
        return
      }
      this.sleep(1000)
      document.getElementById(this.selected[0] + 'phone').click()
      document.getElementById(this.selected[0] + 'phone').focus()

      var selectedId = this.selected[0] + 'row'
      document.getElementById(selectedId).style.backgroundColor = '#86efac'
      console.log(this.$refs[selectedId])

      this.callingId = this.selected[0]
      this.selected.shift()
    },
    phoneCall(e) {
      const data = e.data
      if (data) {
        switch (data.type) {
          case 'rc-call-end-notify':
            var reference = this.callingId + 'row'
            this.$refs[reference][0].style.backgroundColor = '#f3f4f6'
            console.log('rc-call-end-notify:', data.message)
            this.loop()
            break
          default:
            break
        }
      }
    },
    phoneShow: function (phone) {
      if (phone !== null) {
        phone = phone.replace(/[\s()-/+]+/gi, '')
        if (phone.startsWith(1) == true) {
          phone = phone.substring(1)
        }
        return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
      }
      else {
        phone = null
        return phone
      }
    },
    phoneFormatted: function (phone) {
      if (phone !== null) {
        phone = phone.replace(/[\s()-/+]+/gi, '')
        if (phone.startsWith(1) != true) {
          phone = '1' + phone
        }
        return phone
      }
      else {
        phone = null
        return phone
      }
    },
  },
}
</script>
